<template>
  <div>
    <div style="background: white">
      <K2Row justify_content="center" class="position-relative p-4">
        <K2Heading type="h5" class-name="mb-0" color="black">Dashboard (Moment)</K2Heading>
      </K2Row>
    </div>

    <div style="background: white" class="p-4 m-4">
      <K2Filter :filter-list="filterList" @onFilter="handleFilter" @onFilterChange="onFilterChange" />
      <DashboardTable :dataList="feedStat" :dateRange="this.filterList[3].selected" />
    </div>
  </div>
</template>
<script>
import K2Heading from '../../uiComponents/k2Heading/k2Heading'
import { lang } from '../../locale'
import uiVariable from '../../config/uiVariable'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Icon from '../../uiComponents/k2Icon/k2MAIcon'
import K2Text from '../../uiComponents/k2Text/k2Text'
import K2Filter from '../../uiComponents/k2Filter/k2Filter'
import DataSource from '../../data/datasource'
import DashboardTable from './component/dashboardTable'
import K2Button from '../../uiComponents/k2Button/k2Button'

export default {
  name: 'DashboardPage',
  components: { K2Button, DashboardTable, K2Filter, K2Heading, K2Text, K2Icon, K2Row },
  props: ['handleBack', 'post'],
  data() {
    return {
      uiVariable: uiVariable,
      selectedTab: 0,
      filterList: [
        {
          label: 'Academic Year',
          placeholder: 'Filter by academic year',
          optionList: [],
        },
        {
          label: 'Level',
          placeholder: 'Filter by level',
          optionList: [],
        },
        {
          label: 'Class',
          placeholder: 'Filter by class',
          optionList: [],
        },
        {
          label: 'Date',
          placeholder: 'Filter by date',
          selected: [new Date(), new Date()],
        },
      ],

      feedStat: [],
      selectedLevel: null,
      selectedAcademic: null,
      selectedClass: null,
      dateRange: null,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    lang,
    async init() {
      await this.SetThisWeek()
      await this.getSemester()
      await this.getLevel()
      await this.getClass()
      await this.loadStats()
    },
    SetThisWeek() {
      let todayDate = new Date()
      let mondayDay = todayDate.getDate() - todayDate.getDay() + 1
      let sundayDay = mondayDay + 6
      let monday = new Date(todayDate.getFullYear(), todayDate.getMonth(), mondayDay)
      let sunday = new Date(todayDate.getFullYear(), todayDate.getMonth(), sundayDay)
      this.filterList[3].selected = [monday, sunday]
      this.handleFilter('date')
    },
    async getSemester() {
      const response = await DataSource.shared.getFeedFilterSemesterList()
      if (response) {
        response.forEach(d => {
          d.id = d.PK_Semester_ID
          d.label = d.SMT_Code
        })
        this.filterList[0].optionList = response
        this.filterList[0].selected = this.filterList[0].optionList[0]
        // this.getCurrentSchool();
      }
    },
    async getLevel() {
      const response = await DataSource.shared.getFeedFilterLevelList()
      if (response) {
        response.forEach(d => {
          d.id = d.PK_Course_ID
          d.label = d.CRS_Course_Name
          d.type = 'level'
        })
        this.filterList[1].optionList = response
        // this.getCurrentSchool();
      }
    },
    async getClass(levelID) {
      const response = await DataSource.shared.getFeedFilterClassList()
      if (levelID) {
        let arr = []
        response.forEach(d => {
          if (d.PK_Course_ID === levelID) {
            d.id = d.PK_Class_ID
            d.label = d.CLS_ClassName + ' ' + d.CLS_Batch
            d.type = 'class'
            arr.push(d)
          }
        })
        this.filterList[2].optionList = arr
      } else {
        this.classList = response
      }
    },
    async loadStats() {
      this.$vs.loading()

      try {
        const result = await DataSource.shared.getNewsfeedStatsByTeacher('', '', this.selectedAcademic, this.selectedLevel, this.selectedClass, this.dateRange)
        if (result) {
          // if (result.code === '88') {
          //     window.location.replace('/');
          //     console.log('88');
          //     return;
          // }
          this.feedStat = result
        }
      } catch (e) {
        console.log('sortByLevelClass err', e)
      }
      this.$vs.loading.close()
    },
    onFilterChange(value) {
      this.getClass(value)
    },
    handleFilter(type) {
      if (type === null) {
        this.selectedLevel = null
        this.selectedClass = null
        this.selectedAcademic = null
        this.dateRange = null
      } else {
        switch (type) {
          case 'Level':
            this.selectedLevel = this.filterList[1].selected
            break
          case 'Class':
            this.selectedLevel = null
            this.selectedClass = this.filterList[2].selected
            break
          case 'Academic Year':
            this.selectedLevel = null
            this.selectedClass = null
            this.selectedAcademic = this.filterList[0].selected
            break
        }
        if (this.filterList[3].selected) {
          this.dateRange = this.filterList[3].selected.toString()
        }
      }

      this.loadStats()
    },
  },
}
</script>
